import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IntakeWizard from '@/components/IntakeWizard';
import api from '@/lib/api';
import { useClient } from '@/context/ClientContext';
import { toast } from 'sonner';

export default function Onboarding() {
  const navigate = useNavigate();
  const { refresh, selectClient } = useClient();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (payload) => {
    setSubmitting(true);
    try {
      const { data } = await api.post('/clients', payload);
      await refresh();
      selectClient(data.client_id);
      if (data.intake_status === 'complete') {
        toast.success('Client onboarded. Run the AEO assessment from the dashboard.');
      } else {
        toast.success('Client created. Complete the intake to begin the AEO process.');
      }
      navigate('/dashboard');
    } catch (e) {
      toast.error('Failed to onboard client');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <IntakeWizard
      submitLabel="Activate AuthorityOS"
      submitting={submitting}
      onSubmit={onSubmit}
      intro={
        <div className="mb-8">
          <div className="text-xs uppercase tracking-widest text-muted-foreground">Client onboarding</div>
          <h1 className="mt-2 font-display text-3xl tracking-tight">Set up a new client</h1>
          <p className="mt-2 text-muted-foreground text-sm">
            Provide the company brief — the orchestrator and reasoning engine will calibrate the swarm and start the AEO process.
          </p>
        </div>
      }
    />
  );
}
